import {gsap} from "gsap/gsap-core";
import ScrollTrigger from "gsap/ScrollTrigger";
import {CustomEventHandler} from "../../utils/CustomEventHandler";
import {CUSTOM_SCROLL} from "../../common/globalVars";

export default class ScrollToggle{
    constructor(container) {
        this.container = container;
        this.scrollToggleEls = [];
        this.scrollToggleVideos = [];
        this.init();
    }

    init() {
        this.scrollToggleEls = this.container.querySelectorAll('.motion');
        this.scrollToggleVideos = this.container.querySelectorAll('video');
        this.scrollToggleVideos.forEach(
            (video) => {
                video.isPlay = video.getAttribute('autoplay') !== null;
                video.isPlayed = false;
                CustomEventHandler.addHandler(video,'ended', function(){
                    this.isPlayed = true;
                })
            }
        );

        this.onScrollHandler({detail:0});
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
    }

    onScrollHandler(e) {
        this.scrollToggleEls.forEach(
            (el) => {
                let rect = el.getBoundingClientRect();
                if (rect.top < window.innerHeight * (9/10)) {
                    if(rect.top < window.innerHeight  * -2) {
                        this.removeMotionClass(el);
                    } else {
                        this.addMotionClass(el);
                    }
                }
            }
        )

        this.scrollToggleVideos.forEach(
            (video) => {
                let videoRect = video.getBoundingClientRect();
                if (video.getAttribute('loop') !== null)  return;
                if (videoRect.top < window.innerHeight*(9/10)) {
                    if (videoRect.top < - videoRect.height) {
                        if (video.isPlay) {
                            video.isPlay = false;
                            video.pause();
                            video.currentTime = 0;
                            video.isPlayed = false;
                        }
                    } else {
                        if (video.getAttribute('autoplay') === null) {
                            if (!video.isPlayed) {
                                if (!video.isPlay) {
                                    video.isPlay = true;
                                    video.play();
                                }
                            }
                        }
                    }
                } else {
                        if (video.isPlay) {
                            video.isPlay = false;
                            video.pause();
                            video.currentTime = 0;
                            video.isPlayed = false;
                        }
                }
            }
        );
    }

    addMotionClass(el) {
        if (!(el.classList.contains('onTrans'))) {
            el.classList.add('onTrans');
        }
    }

    removeMotionClass(el) {
        if ((el.classList.contains('onTrans'))) {
            el.classList.remove('onTrans');
        }
    }

    setDestroy() {
        //todo destroy 만들기
        this.scrollToggleTrigger.forEach(scrollTrigger => {
            scrollTrigger.kill();
        })

        // console.log(ScrollTrigger.getAll());
        this.scrollToggleTrigger = undefined;
        this.scrollToggleTrigger = [];
    }
}
